<script>
	export let pills = true;
</script>

<div>
	<ul class="nav" class:nav-pills={pills}>
		<slot />
	</ul>
</div>
